import { Callout } from "@clipboard-health/ui-components";
import { AgentStage } from "@src/appV2/Agents";
import { useAttendanceScorePolicyLinks } from "@src/appV2/AttendanceScore/hooks/featureFlags";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function AccountDeactivatedCallout() {
  const { stage } = useDefinedWorker();

  const { understandingAccountStatus } = useAttendanceScorePolicyLinks();

  if (stage !== AgentStage.DEACTIVATED) {
    return null;
  }

  return (
    <Callout
      title="Your account is deactivated"
      iconType="remove"
      sx={(theme) => ({
        backgroundColor: theme.palette.intent?.error.background,
        color: theme.palette.intent?.error.text,
      })}
      onClick={() => window.open(understandingAccountStatus?.url, "_blank")}
    />
  );
}
